const columns = [
  { name: 'title', title: 'Titel' },
  { name: 'is_default', title: 'Standard' },
  // RITA-1526: kleine Vorschau des Logos; Klick öffnet den Logo-Dialog (Formatter in features/options).
  // getCellValue hält die data:-URL aus Suche, Filter und Sortierung des Grids heraus.
  {
    name: 'logo_data_url',
    title: 'Logo',
    getCellValue: (row: { logo_data_url?: string | null }) => (row.logo_data_url ? 'Logo' : ''),
  },
];
export default columns;
